import { localisedPath } from 'common/url_locale_helper';
import { CHANGE_IN_MEMBERSHIP_URL_KEY } from './appConstants';

// Shop.
export const autoShip = () => localisedPath('/auto-ship');
export const shopPods = () => localisedPath('/shop/pods');

// Account.
export const account = () => localisedPath(`/account`);

// Membership.
export const cancelMembership = () =>
  localisedPath(`/account/membership/cancel`);
export const editMembershipOrderDate = () =>
  localisedPath(`/account/membership/order-date/edit`);
export const editMembershipPaymentMethod = () =>
  localisedPath(`/account/membership/payment-method/edit`);
export const editMembershipPods = () =>
  localisedPath(`/account/membership/pods/edit`);
export const editMembershipShipping = () =>
  localisedPath(`/account/membership/shipping/edit`);
export const editMembershipBilling = () =>
  localisedPath(`/account/membership/billing/edit`);
export const membership = () => localisedPath(`/account/membership`);
export const postponeMembership = () =>
  localisedPath(`/account/membership/postpone`);
export const reviewMembershipPods = () =>
  localisedPath(`/account/membership/pods/review`);
export const newMembership = () => localisedPath(`/account/membership/new`);
export const changeInMembershipModal = () =>
  `?${CHANGE_IN_MEMBERSHIP_URL_KEY}=true`;
export const membershipWithModal = () =>
  `${membership()}${changeInMembershipModal()}`;

// Orders
export const orders = () => localisedPath(`/account/orders`);
export const order = ({ number } = {}) =>
  localisedPath(`/account/orders/${number}`);

export const cancelOrder = ({ number } = {}) =>
  localisedPath(`/account/orders/${number}/cancel`);

// Profile.
export const profile = () => localisedPath(`/account/profile`);
export const editProfile = () => localisedPath(`/account/profile/edit`);
export const editProfilePhone = () => localisedPath(`/account/phone/edit`);
export const editProfileEmail = () => localisedPath(`/account/email/edit`);

// Loss Protection
export const lossProtection = () => localisedPath('/loss_protection');

// Signout.
export const signout = () => localisedPath(`/signout`);

// Register.
export const registerProduct = () => localisedPath(`/account/register`);

// Warranty Flow
export const claimWarranty = pid => localisedPath(`/claim-warranty?pid=${pid}`);
